<template>
  <div>
    <Select v-model="selectedVersion"
            :placeholder="$t('form.select_bom_version')"
            filterable
            transfer
            :clearable="clearable"
            @on-change="handleSelectVersion"
            :disabled="disabled">
      <Option v-for="v in bomVersions" :value="v.ProductID" :key="v.ProductID">{{v.ProductID}} {{v.CurVersion}}</Option>
    </Select>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  name: 'erp-versions-select',
  props: {
    bomId: {
      required: true
    },
    versionId: {
      type: Number
    },
    versionNumber: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedVersion: null,
      bomVersions: []
    }
  },
  watch: {
    bomId: function () {
      this.bomVersions = []
      this.selectedVersion = this.versionNumber
      this.handleLoadBomVersions()
    },
    bomVersions: {
      handler () {
        this.$emit('updateVersionList', this.bomVersions)
      },
      deep: true
    }
  },
  mounted () {
    this.selectedVersion = this.versionNumber
    this.handleLoadBomVersions()
  },
  methods: {
    ...mapActions([
      'getErpBomTree'
    ]),
    handleLoadBomVersions: function () {
      if (this.bomId) {
        this.loading = true
        this.getErpBomTree({ id: this.bomId, max_depth: 1 }).then(res => {
          this.bomVersions = res
          this.handleSelectVersion()
        }).finally(() => {
          this.loading = false
        })
      }
    },
    setSelectedVersion (version) {
      this.selectedVersion = version
    },
    handleSelectVersion () {
      let findVersion = _.find(this.bomVersions, (v) => {
        return v.ProductID === this.selectedVersion
      })
      if (findVersion) {
        this.$emit('update:versionNumber', findVersion.ProductID)
        this.$emit('update:versionId', findVersion.ProductID)
        this.$emit('versionSelected', findVersion)
      } else {
        this.selectedVersion = null
        this.$emit('update:versionNumber', null)
        this.$emit('update:versionId', null)
        this.$emit('versionSelected', null)
      }
    }
  }
}
</script>

<style scoped>

</style>
